import React from 'react';

import { uuid } from 'uuidv4';
import { Add } from '@mui/icons-material';
import { Alert, Link, Stack, Text } from 'library/ui';
import { client } from 'shared';

import { BasePayRow } from './BasePayRow';
import { PayRow } from './PayRow';
import { useRequirementsAndPayContext } from '../context';

import type { IManagedScale } from '../types';

export function PayBody({ editing }: { editing: boolean }) {
    const { scales, initialScale, qualifications, updateScales, replaceAllScales, stateHasRecommendedPayScales } =
        useRequirementsAndPayContext();

    function onClick() {
        const previousScale = scales?.at(-1) ?? initialScale;
        const newScale = {
            id: uuid(),
            rate: (scales?.at(-1)?.rate ?? 14) + 1,
            description: `${(scales?.at(-1)?.rate ?? 14) + 1}`,
            qualifications: Array.from(
                previousScale.qualifications.map((x) => {
                    return { ...x };
                }),
            ),
        };
        updateScales(newScale);
    }

    function onDefaultChange() {
        client('api/pay-scale/recommended/').then((response: IManagedScale[]) => {
            replaceAllScales(response);
        });
    }

    return (
        <Stack gap="md">
            {!editing && <BasePayRow scale={initialScale} qualificationChoices={qualifications} />}
            {scales.map(
                (scale: IManagedScale) =>
                    (scale.id !== initialScale.id || editing) && (
                        <PayRow key={scale.id} scale={scale} editing={editing} />
                    ),
            )}
            <Stack gap="sm">
                <Link onClick={onClick} icon={<Add sx={{ fontSize: 18 }} />}>
                    Add another pay rate
                </Link>
                {scales?.length < 3 && (
                    <Text size="sm" tone="error">
                        We suggest doing this as teachers who have more than the minimum requirements may not be
                        interested in the position.
                    </Text>
                )}
            </Stack>
            {stateHasRecommendedPayScales() && (
                <Alert variant="info">
                    <Stack gap="sm">
                        <Link onClick={onDefaultChange} weight="semibold">
                            NEED HELP? Use Tandem&apos;s recommended pay scale by clicking here.
                        </Link>
                        <Text>This will overwrite your minimum requirements.</Text>
                    </Stack>
                </Alert>
            )}
        </Stack>
    );
}
